var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeedbackCommentIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2001_45)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2001_45",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0H0V16H16V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2001_45)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.0026 15.2054C7.5426 15.2054 7.10927 14.972 6.8026 14.5654L5.8026 13.232C5.7826 13.2054 5.7026 13.172 5.66927 13.1654H5.33594C2.55594 13.1654 0.835938 12.412 0.835938 8.66536V5.33203C0.835938 2.38536 2.38927 0.832031 5.33594 0.832031H10.6693C13.6159 0.832031 15.1693 2.38536 15.1693 5.33203V8.66536C15.1693 11.612 13.6159 13.1654 10.6693 13.1654H10.3359C10.2826 13.1654 10.2359 13.192 10.2026 13.232L9.2026 14.5654C8.89594 14.972 8.4626 15.2054 8.0026 15.2054ZM5.33594 1.83203C2.94927 1.83203 1.83594 2.94536 1.83594 5.33203V8.66536C1.83594 11.6787 2.86927 12.1654 5.33594 12.1654H5.66927C6.00927 12.1654 6.39594 12.3587 6.6026 12.632L7.6026 13.9654C7.83594 14.272 8.16927 14.272 8.4026 13.9654L9.4026 12.632C9.6226 12.3387 9.96927 12.1654 10.3359 12.1654H10.6693C13.0559 12.1654 14.1693 11.052 14.1693 8.66536V5.33203C14.1693 2.94536 13.0559 1.83203 10.6693 1.83203H5.33594Z",
    fill: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.0026 7.9974C7.62927 7.9974 7.33594 7.6974 7.33594 7.33073C7.33594 6.96406 7.63594 6.66406 8.0026 6.66406C8.36927 6.66406 8.66927 6.96406 8.66927 7.33073C8.66927 7.6974 8.37594 7.9974 8.0026 7.9974Z",
    fill: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 7.9974C10.2933 7.9974 10 7.6974 10 7.33073C10 6.96406 10.3 6.66406 10.6667 6.66406C11.0333 6.66406 11.3333 6.96406 11.3333 7.33073C11.3333 7.6974 11.04 7.9974 10.6667 7.9974Z",
    fill: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.33854 7.9974C4.96521 7.9974 4.67188 7.6974 4.67188 7.33073C4.67188 6.96406 4.97187 6.66406 5.33854 6.66406C5.70521 6.66406 6.00521 6.96406 6.00521 7.33073C6.00521 7.6974 5.71187 7.9974 5.33854 7.9974Z",
    fill: "#5A5A5A"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2001_45"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedbackCommentIcon);
export default __webpack_public_path__ + "static/media/feedback-comment-icon.c0d300aa67bf33c044e3a52a24b855df.svg";
export { ForwardRef as ReactComponent };